module.exports = __webpack_public_path__ + "static/media/PorscheNextTT-Regular.4ed5cada.ttf";